
import React, { useContext } from 'react';
import AppContext from '../context/app/appContext';
import { getItemsCount, getCurrentPage } from '../context/selectors';
import ListItem from './ListItem';
import config from '../config';


import { getItems } from '../context/selectors';

const List = (props) => {

    const appContext = useContext(AppContext);

    const currentPage = getCurrentPage(appContext);
    const itemsPerPage = config.itemsPerPage;


    const paginate = (array, page_size, page_number) => {
        return array.slice((page_number - 1) * page_size, page_number * page_size);
    };

    return appContext.dataFiltered ? (
        <ul className="items four bb">
            {paginate(getItems(appContext), itemsPerPage, currentPage).map((item, i) => {
                let outputItem = {...item};
                outputItem.f = appContext.dictionaries['f'][item.f]
                outputItem.gn = appContext.dictionaries['gn'][item.gn]
                return (<ListItem key={i} json={outputItem} />)
            })}
        </ul>
    ) : '';

}

export default List;